function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module table/commands/setheaderrowcommand
 */
import { Command } from 'ckeditor5/src/core';
import { updateNumericAttribute } from '../utils/common';
import { getRowIndexes, getSelectionAffectedTableCells } from '../utils/selection';
import { getVerticallyOverlappingCells, splitHorizontally } from '../utils/structure';
/**
 * The header row command.
 *
 * The command is registered by {@link module:table/tableediting~TableEditing} as the `'setTableColumnHeader'` editor command.
 *
 * You can make the row containing the selected cell a [header](https://www.w3.org/TR/html50/tabular-data.html#the-th-element) by executing:
 *
 *		editor.execute( 'setTableRowHeader' );
 *
 * **Note:** All preceding rows will also become headers. If the current row is already a header, executing this command
 * will make it a regular row back again (including the following rows).
 *
 * @extends module:core/command~Command
 */

var SetHeaderRowCommand = /*#__PURE__*/function (_Command) {
  _inherits(SetHeaderRowCommand, _Command);

  var _super = _createSuper(SetHeaderRowCommand);

  function SetHeaderRowCommand() {
    _classCallCheck(this, SetHeaderRowCommand);

    return _super.apply(this, arguments);
  }

  _createClass(SetHeaderRowCommand, [{
    key: "refresh",
    value:
    /**
     * @inheritDoc
     */
    function refresh() {
      var _this = this;

      var model = this.editor.model;
      var selectedCells = getSelectionAffectedTableCells(model.document.selection);
      var isInTable = selectedCells.length > 0;
      this.isEnabled = isInTable;
      /**
       * Flag indicating whether the command is active. The command is active when the
       * {@link module:engine/model/selection~Selection} is in a header row.
       *
       * @observable
       * @readonly
       * @member {Boolean} #value
       */

      this.value = isInTable && selectedCells.every(function (cell) {
        return _this._isInHeading(cell, cell.parent.parent);
      });
    }
    /**
     * Executes the command.
     *
     * When the selection is in a non-header row, the command will set the `headingRows` table attribute to cover that row.
     *
     * When the selection is already in a header row, it will set `headingRows` so the heading section will end before that row.
     *
     * @fires execute
     * @param {Object} options
     * @param {Boolean} [options.forceValue] If set, the command will set (`true`) or unset (`false`) the header rows according to
     * the `forceValue` parameter instead of the current model state.
     */

  }, {
    key: "execute",
    value: function execute() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (options.forceValue === this.value) {
        return;
      }

      var model = this.editor.model;
      var selectedCells = getSelectionAffectedTableCells(model.document.selection);
      var table = selectedCells[0].findAncestor('table');

      var _getRowIndexes = getRowIndexes(selectedCells),
          first = _getRowIndexes.first,
          last = _getRowIndexes.last;

      var headingRowsToSet = this.value ? first : last + 1;
      var currentHeadingRows = table.getAttribute('headingRows') || 0;
      model.change(function (writer) {
        if (headingRowsToSet) {
          // Changing heading rows requires to check if any of a heading cell is overlapping vertically the table head.
          // Any table cell that has a rowspan attribute > 1 will not exceed the table head so we need to fix it in rows below.
          var startRow = headingRowsToSet > currentHeadingRows ? currentHeadingRows : 0;
          var overlappingCells = getVerticallyOverlappingCells(table, headingRowsToSet, startRow);

          var _iterator = _createForOfIteratorHelper(overlappingCells),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var _ref2 = _step.value;
              var cell = _ref2.cell;
              splitHorizontally(cell, headingRowsToSet, writer);
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }

        updateNumericAttribute('headingRows', headingRowsToSet, table, writer, 0);
      });
    }
    /**
     * Checks if a table cell is in the heading section.
     *
     * @param {module:engine/model/element~Element} tableCell
     * @param {module:engine/model/element~Element} table
     * @returns {Boolean}
     * @private
     */

  }, {
    key: "_isInHeading",
    value: function _isInHeading(tableCell, table) {
      var headingRows = parseInt(table.getAttribute('headingRows') || 0);
      return !!headingRows && tableCell.parent.index < headingRows;
    }
  }]);

  return SetHeaderRowCommand;
}(Command);

export { SetHeaderRowCommand as default };